import { Menus, ClinicSupplies } from "../../../../pages/platforms/physician";
import { Services } from "../../../../pages/platforms/cashier";
import Appointments from "../../../../pages/platforms/clinical/appointment";
import Billing from "../../../../pages/platforms/clinical/billing";
import DailyCollections from "../../../../pages/platforms/clinical/collections";
import Schedules from "../../../../pages/platforms/clinical/schedules";
import Dashboard from "../../../../pages/platforms/clinical/dashboard";

const clinical = [
  {
    name: "Dashboard",
    icon: "tachometer-alt",
    path: "/bulletin",
    title:
      "Displays announcements and system-wide updates for the frontdesk team.",
    component: Dashboard,
  },
  {
    name: "Clinic Desk",
    path: "/consultations",
    icon: "stethoscope",
    children: [
      {
        name: "Appointments",
        path: "/appointments",
        icon: "calendar-check",
        title: "Booking, check-in, queue, cancelled, done",
        component: Appointments,
      },
      {
        name: "Billing", // Settlements
        path: "/billing",
        icon: "cash-register",
        title:
          "Secretary billing for confirmed appointments under tagged physicians",
        component: Billing,
      },
      {
        name: "Daily Collections",
        path: "/collections",
        icon: "cash-register",
        title: "Consultation payment and POS",
        component: DailyCollections,
      },
      {
        name: "Patient Records",
        path: "/records",
        icon: "folder-open",
        title: "Search and view patient records",
        // component: Records,
      },
      {
        name: "Physician Schedule",
        path: "/schedules",
        icon: "calendar-alt",
        title: "Doctor clinic schedule and availability",
        component: Schedules,
      },
    ],
  },
  {
    name: "Services", //viewing only
    path: "/offers",
    icon: "list",
    children: [
      /**
       * a group of related services
       */
      {
        name: "Menus",
        path: "/menus",
        icon: "cogs",
        component: Menus,
      },
      /**
       *  a single service
       */
      {
        name: "examinations",
        path: "/services",
        icon: "tools",
        component: Services,
      },
    ],
  },
  {
    name: "Liability",
    path: "/liability",
    icon: "tv",
    children: [
      {
        name: "Supply",
        title: "stocks",
        icon: "box",
        path: "/supply",
        component: ClinicSupplies,
      },
    ],
  },
  {
    name: "Merchandise",
    icon: "list",
    path: "/clinical/merchandise",
    children: [
      {
        name: "Products",
        icon: "cogs",
        path: "/products",
      },
      {
        name: "Stocks",
        icon: "tools",
        path: "/stocks",
      },
    ],
  },
];

export default clinical;
